import {
  takeLatest, call, put, cancel, SagaReturnType,
} from 'redux-saga/effects';

import * as request from 'app/lib/provider/request';

import * as cardActions from '../actions';

export const config = {
  action: cardActions.loadData.type,
  method: takeLatest,
};

export function* func(action: SagaReturnType<typeof cardActions.loadData>) {
  const { payload } = action;

  let response: SagaReturnType<typeof request.data> | undefined;

  if (typeof window !== 'undefined' && typeof ((window as any)?.__PRELOADED_DATA__) !== 'undefined') {
    response = (window as any)?.__PRELOADED_DATA__;
  }

  if (!response) {
    try {
      response = yield call(() => request.data(payload.cardType, payload.cardParam, payload.cardCode, payload.options));
    } catch (error) {
      yield put(cardActions.loadError((error as Error).message));
      yield cancel(); return;
    }
  }

  if (response?.error) {
    yield put(cardActions.loadError(response?.error));
    yield cancel(); return;
  }

  const { common, pages, resources } = response?.data || {};
  if (!common || !pages || !resources) {
    yield put(cardActions.loadError('Unable to load data'));
    yield cancel(); return;
  }

  yield put(cardActions.setData(common, pages, resources));
}
